import { UserAccountModel } from './user-account';
import { AccountParametersModel } from './account-parameters';
import { EnumType } from './enums/enum';
import { OptionMenuModel } from './option-menu';

export class AccountModel {
 
    user_account: UserAccountModel;
    account_parameters: AccountParametersModel;
    option_menu: OptionMenuModel[];

    token: string;
    selected_role: string;

    constructor() {
        this.user_account = new UserAccountModel();
        this.account_parameters = new AccountParametersModel();
    }

    getSelectedRoleByHierarchy() {
        if (this.user_account !== undefined) {
            if (this.user_account.roles.sys_admin === true) {
                this.selected_role = EnumType.Role.SYS_ADMIN;
            } else if (this.user_account.roles.account_admin === true) {
                this.selected_role = EnumType.Role.ACCOUNT_ADMIN;
            } else {
                this.selected_role = undefined;
            }
        } else {
            this.selected_role = undefined;
        }
    }

}
